/* global google */
export const GetSuggestions = async (searchText) => {
  let result;

  try {
    const rawResult = await searchLocation(searchText);
    result = rawResult.map((res) => {
      return {
        id: res.place_id,
        value: res.description,
      };
    });
  } catch (err) {
    result = null;
  }

  return result;
};

// Auxiliary functions
// wrap google api's callback to an async function
const searchLocation = async (val) => {
  let promise = await new Promise((resolve, reject) => {
    var displaySuggestions = (predictions, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        reject(status);
      }
      resolve(predictions);
    };

    var service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions(
      {
        input: val,
        types: ["geocode"],
      },
      displaySuggestions
    );
  }).catch(function (err) {
    throw err;
  });

  return promise;
};

export const GetGeocoder = async (lat, lng) => {
  let promise = await new Promise((resolve, reject) => {
    const latlng = {
      lat: lat,
      lng: lng,
    };

    var service = new google.maps.Geocoder();
    service
      .geocode({ location: latlng })
      .then((response) => {
        if (response.results[0]) {
          let result = {
            id: response.results[0].place_id,
            value: response.results[0].formatted_address,
          };
          resolve(result);
        } else {
          window.alert("No results found");
        }
      })
      .catch((e) => reject(e));
  }).catch(function (err) {
    throw err;
  });

  return promise;
};

export const GetGeocoderInputs = async (prettyAdress) => {
  let promise = await new Promise((resolve, reject) => {
    var service = new google.maps.Geocoder();
    service
      .geocode({
        address: prettyAdress,
      })
      .then((response) => {
        const { results } = response;

        if (results.length > 0) {
          let address = [];
          address.prettyAddress = prettyAdress;
          results[0].address_components.forEach(function (c) {
            switch (c.types[0]) {
              case "street_number":
                address.buildingNumber = c.long_name;
                break;
              case "route":
                address.street = c.long_name;
                break;
              case "neighborhood":
              case "locality": // North Hollywood or Los Angeles?
                address.city = c.long_name;
                break;
              case "administrative_area_level_1": //  Note some countries don't have states
                address.State = c.long_name;
                break;
              case "postal_code":
                address.postalCode = c.long_name;
                break;
              case "country":
                address.Country = c.long_name;
                break;
            }
          });
          resolve(address);
        } else {
          window.alert("No results found");
        }
      })
      .catch((e) => reject(e));
  }).catch(function (err) {
    throw err;
  });

  return promise;
};
